import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.reflect.construct";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";
import _debounce from "lodash/debounce";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import * as React from 'react';
import classNames from 'classnames';
import { AlignBox } from "../Align";
import AlignContext, { inertAlignContextProps } from "../Align/AlignContext";
import Box from "../Box";
import { ButtonLink } from "../Button";
import Icon from "../Icon";
import { info, delete as deleteIcon } from "../Icon/Assets";
import Spinner from "../Spinner";
import { Body, BodyAlt, BodyAltTextProps } from "../Text";
import ResizeObserver from 'resize-observer-polyfill';

var getBackgroundColor = function getBackgroundColor(color) {
  switch (color) {
    case 'green':
      return 'green50';

    case 'red':
      return 'red50';

    case 'yellow':
      return 'yellow50';

    case 'offset':
      return 'offset';

    default:
      return 'white';
  }
};

var getIconColor = function getIconColor(color) {
  switch (color) {
    case 'default':
    case 'offset':
      return 'gray';

    default:
      return color;
  }
};

var getRole = function getRole(color) {
  /*
    The role="status" will politely alert users.
    See https://www.w3.org/TR/wai-aria-1.1/#status
  */
  switch (color) {
    case 'red':
    case 'yellow':
      return 'status';

    default:
      return undefined;
  }
};

var actionsLeftMargin = 12;

var Notice = /*#__PURE__*/function (_React$Component) {
  _inherits(Notice, _React$Component);

  var _super = _createSuper(Notice);

  function Notice() {
    var _this;

    _classCallCheck(this, Notice);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.content = void 0;
    _this.textMeasureEl = void 0;
    _this.actions = void 0;
    _this.state = {
      charCount: null,
      charWidth: null,
      contentWidth: null,
      lineCount: null
    };
    _this.observer = null;

    _this.actionsRef = function (node) {
      _this.actions = node;
    };

    _this.contentRef = function (node) {
      _this.content = node;
    };

    _this.textMeasureRef = function (node) {
      _this.textMeasureEl = node;
    };

    _this.setLineCount = function () {
      _this.setContentWidth();

      _this.setCharacterCount();

      var _this$state = _this.state,
          charWidth = _this$state.charWidth,
          charCount = _this$state.charCount,
          contentWidth = _this$state.contentWidth;

      if (charWidth && charCount && contentWidth) {
        var lineCount = charCount * charWidth / contentWidth;

        _this.setState({
          lineCount: lineCount
        });
      }
    };

    _this.handleSizeChange = _debounce(_this.setLineCount, 250);

    _this.renderDismiss = function () {
      return _this.props.onDismiss ? /*#__PURE__*/React.createElement(ButtonLink, {
        className: "Notice-dismiss",
        color: "gray",
        icon: deleteIcon,
        onClick: _this.props.onDismiss // @TODO: l10n
        ,
        label: "Dismiss",
        hideLabel: true
      }) : null;
    };

    return _this;
  }

  _createClass(Notice, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          actions = _this$props.actions,
          children = _this$props.children,
          description = _this$props.description;

      if ((children || description) && actions) {
        this.setCharacterCount();
        this.setCharacterWidth();
        this.setContentWidth();

        if (this.content) {
          this.observer = new ResizeObserver(this.handleSizeChange);
          this.observer.observe(this.content);
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.observer) {
        this.observer.disconnect();
      }
    }
  }, {
    key: "setCharacterCount",
    value: function setCharacterCount() {
      if (this.textMeasureEl) {
        this.setState({
          charCount: this.textMeasureEl.textContent.length
        });
      }
    }
  }, {
    key: "setCharacterWidth",
    value: function setCharacterWidth() {
      // Measures the average character width of the description and children.
      // Looks at the total width and total character count of ghost content,
      // then divides the width by number of characters to get the average
      // character width.
      //
      // We use this method because it's the ~most accurate when considering
      // characters in several languages (ie. asian characters are much wider
      // Measures like CSS's `ch` base character width on the 0 character,
      // which is  than latin characters) much more narrow than the average
      // width of Japanese characters.
      //
      // We later use the character width to make a best-guess at the number
      // of lines of text the description takes up.
      //
      if (this.textMeasureEl) {
        var width = this.textMeasureEl.clientWidth;
        var count = this.textMeasureEl.textContent.length;
        this.setState({
          charWidth: width / count
        });
      }
    }
  }, {
    key: "setContentWidth",
    value: function setContentWidth() {
      // Calculates the width of the content area when actions are present
      // and stores it in this.state.contentWidth
      // We later use this width in getLineCount calculate a best guess at
      // the number of lines the description would take up when actions are
      // present.
      var content = this.content,
          actions = this.actions;

      if (content) {
        var actionsWidth = actions ? actions.clientWidth + actionsLeftMargin : 0;
        var contentWidth = actionsWidth > content.clientWidth ? content.clientWidth : content.clientWidth - actionsWidth;
        this.setState({
          contentWidth: contentWidth
        });
      }
    }
  }, {
    key: "renderDescription",
    value: function renderDescription() {
      var _this$props2 = this.props,
          description = _this$props2.description,
          children = _this$props2.children;
      return /*#__PURE__*/React.createElement(React.Fragment, null, description && /*#__PURE__*/React.createElement(Body, {
        color: "default",
        display: "block"
      }, description), children);
    }
  }, {
    key: "renderGhostContent",
    value: function renderGhostContent() {
      // Renders the both description and children in an invisible
      // container without text wrapping.
      // Used to measure the total width of the text and average
      // character width in `setCharacterWidth`
      return /*#__PURE__*/React.createElement("div", {
        className: "Notice-ghostContent",
        ref: this.textMeasureRef
      }, this.renderDescription());
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          actions = _this$props3.actions,
          children = _this$props3.children,
          className = _this$props3.className,
          color = _this$props3.color,
          description = _this$props3.description,
          divider = _this$props3.divider,
          onDismiss = _this$props3.onDismiss,
          icon = _this$props3.icon,
          title = _this$props3.title,
          remaining = _objectWithoutProperties(_this$props3, ["actions", "children", "className", "color", "description", "divider", "onDismiss", "icon", "title"]);

      var classes = classNames('Notice', className);
      var dividerValue = divider ? {
        side: 'bottom',
        width: 1,
        color: 'light'
      } : null;
      var stacked = false;

      if (actions) {
        stacked = this.state.lineCount && this.state.lineCount > 2;
      }

      var flexValues = {
        flexBasis: '0',
        flexGrow: 1,
        flexShrink: 1
      };
      return /*#__PURE__*/React.createElement(Box, _extends({}, remaining, {
        role: getRole(color),
        background: getBackgroundColor(color),
        className: classes,
        divider: dividerValue,
        padding: {
          horizontal: 20,
          vertical: 12
        },
        flex: {
          alignItems: stacked ? 'flex-start' : 'center'
        }
      }), /*#__PURE__*/React.createElement(AlignBox, _extends({
        reference: BodyAltTextProps
      }, flexValues), icon && /*#__PURE__*/React.createElement(Box, {
        padding: {
          right: 12
        }
      }, icon === 'spinner' ? /*#__PURE__*/React.createElement(Spinner, null) : /*#__PURE__*/React.createElement(Icon, {
        className: "Notice-icon",
        color: getIconColor(color),
        icon: icon,
        size: 12
      })), /*#__PURE__*/React.createElement(Box, _extends({
        flex: {
          alignItems: stacked ? 'flex-start' : 'center',
          direction: stacked ? 'column' : 'row',
          justifyContent: 'space-between'
        }
      }, flexValues, {
        boxRef: this.contentRef
      }), /*#__PURE__*/React.createElement(Box, _extends({
        flex: {
          direction: 'column'
        }
      }, flexValues), title && /*#__PURE__*/React.createElement(BodyAlt, {
        className: "Notice-title",
        color: "dark",
        display: "block"
      }, title), (description || children) && /*#__PURE__*/React.createElement("span", {
        className: "Notice-description"
      }, this.renderDescription())), /*#__PURE__*/React.createElement(AlignContext.Provider, {
        value: inertAlignContextProps
      }, /*#__PURE__*/React.createElement(Box, {
        boxRef: this.actionsRef,
        className: "Notice-end",
        hideIfEmpty: true,
        margin: {
          vertical: stacked ? 8 : 0,
          left: stacked ? 0 : actionsLeftMargin
        }
      }, actions)))), /*#__PURE__*/React.createElement(Box, {
        hideIfEmpty: true,
        padding: {
          left: 16
        }
      }, this.renderDismiss()), // Used to measure character width
      (description || children) && actions && this.renderGhostContent());
    }
  }]);

  return Notice;
}(React.Component);

Notice.defaultProps = {
  color: 'default',
  divider: true,
  icon: info
};
export default Notice;